export default __webpack_public_path__ + "static/media/3-step.b23c05cc.png";